import React from 'react'
import injectSheet from 'react-jss'
import styles from './work-skeleton.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'
import EntrySkeleton from './entry-skeleton/entry-skeleton'

const WorkSkeleton = ({ classes }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.allCell}>
          <Bone className={classes.all} />
        </HeadCell>
        <HeadCell className={classes.dateCell}>
          <Bone className={classes.date} />
        </HeadCell>
        <HeadCell className={classes.thumbnailCell}>
          <Bone className={classes.thumbnail} />
        </HeadCell>
        <HeadCell className={classes.titleCell} />
        <HeadCell className={classes.staCell}>
          <Bone className={classes.sta} />
        </HeadCell>
        <HeadCell className={classes.ageGroupCell}>
          <Bone className={classes.ageGroup} />
        </HeadCell>
        <HeadCell className={classes.publishedCell}>
          <Bone className={classes.published} />
        </HeadCell>
        <HeadCell className={classes.contextMenuCell}>
          <Bone className={classes.bulkAction} />
        </HeadCell>
      </tr>
    </thead>
    <tbody>
      <EntrySkeleton titleWidth={30} />
      <EntrySkeleton titleWidth={50} />
      <EntrySkeleton titleWidth={20} />
      <EntrySkeleton titleWidth={60} />
      <EntrySkeleton titleWidth={25} />
    </tbody>
  </Table>
)

export default injectSheet(styles)(WorkSkeleton)
